import { useEffect, useRef } from 'react'
import { useSession, User } from '@slerp/accounts'
import { useHubspotChat } from 'hooks/useHubspotChat'

const HubspotChat = () => {
  const { user } = useSession()
  const hubspotJWT = useHubspotChat(user as User)
  const hasLoadedRef = useRef(false)

  useEffect(() => {
    const isPrintOrder = window.location.pathname.startsWith('/print-order')

    if (!hubspotJWT || isPrintOrder) {
      return
    }

    const identifyAndLoad = () => {
      ;(window as any).hsConversationsSettings = {
        loadImmediately: false,
        identificationEmail: user?.email,
        identificationToken: hubspotJWT
      }

      // Only clear/remove if the widget was previously loaded (token refresh)
      if (
        hasLoadedRef.current &&
        (window as any).HubSpotConversations?.widget?.isLoaded?.()
      ) {
        ;(window as any).HubSpotConversations.clear?.({ resetWidget: true })
        ;(window as any).HubSpotConversations.widget.remove?.()
      }

      ;(window as any).HubSpotConversations?.widget?.load?.()
      hasLoadedRef.current = true
    }

    if ((window as any).HubSpotConversations) {
      identifyAndLoad()
    } else {
      const t = setInterval(() => {
        if ((window as any).HubSpotConversations) {
          clearInterval(t)
          identifyAndLoad()
        }
      }, 200)
      return () => clearInterval(t)
    }
  }, [hubspotJWT, user?.email])

  return null
}

export default HubspotChat
